import * as Styled from './styles'
import { Props } from '../interfaces'
import { ReactElement } from 'react'

const PrimaryButton = ({
  show,
  onClick,
  children,
  type,
  forWhatsApp = false,
}: Props): ReactElement => {
  return (
    show && (
      <Styled.PrimaryButton
        onClick={onClick}
        color="primary"
        type={type}
        forWhatsApp={forWhatsApp}
      >
        {children}
      </Styled.PrimaryButton>
    )
  )
}

PrimaryButton.defaultProps = {
  type: 'button',
}

export default PrimaryButton
